import { render } from "./loader.vue?vue&type=template&id=b54670b0"
const script = {}

import "./loader.vue?vue&type=style&index=0&id=b54670b0&lang=css"

import exportComponent from "/Users/voltz/Documents/Github/Website/CraftMasters/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__